<template>
  <el-dialog :visible="visible" title="商品详情" @close="$emit('close')" top="5vh" width="1200">
    <div>
      <WmsTable :columns="columns" :isPagination="false" :hasHeader="false" :dataSource="data" rowKey="pkgCode"  :scrollY="650" style="height:700px">
      </WmsTable>
    </div>
  </el-dialog>
</template>

<script>
import WmsTable from '@/components/WmsTable'
export default {
  name: 'InterBtnBox',
  components: { WmsTable },
  data() {
    return {
      columns: [
        {
          title: '批次号',
          key: 'pkgCode',
          dataIndex: 'pkgCode',
          rowKey: 'key'
        },
        {
          title: '数量',
          key: 'amount',
          dataIndex: 'amount',
          rowKey: 'key',
          width:120
        },
        {
          title: '商品类型',
          key: 'productType',
          dataIndex: 'productType',
          rowKey: 'key',
          customRender:(text)=>{
            return text ==1?'普通商品':text==2?'OEM商品':text==3?'组合商品':''
          }
        },
        {
          title: '内容',
          key: 'content',
          dataIndex: 'content',
          rowKey: 'key',
        },
        {
          title: '归属订单',
          key: 'platformOrderNo',
          dataIndex: 'platformOrderNo',
          rowKey: 'key'
        }
      ]
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  computed: {},
  methods: {}
}
</script>

<style scoped>

.dialogTitle {
  height: 60px;
  width: 100%;
  font-size: 20px;
  text-align: center;
  line-height: 60px;
  background-color: #00284d;
  color: #e8e8e8;
}
</style>
